import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import Select from "react-select";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";

function Create() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(false);
    const [factorNumber, setFactorNumber] = React.useState('');
    const [battery_qty, setQty] = React.useState(0);
    const [battery_qty1, setQty1] = React.useState('');
    const [batteryQtyDetails, setQtyDetails] = React.useState([]);
    const [basics, setBasics] = React.useState([]);
    const [description, setDescription] = React.useState('');
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState();
    const [batteryDescription, setBatteryDescription] = React.useState('');
    const [ampType, setAmpType] = React.useState('');
    const [batteryType, setBatteryType] = React.useState('');
    const [brand, setBrand] = React.useState('');


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        API.getUserInfo()
            .then((response) => {

                const params = {
                    list: 1,
                    count: 500,
                    processFor: 'Sales',
                }
                API.getVendors(params)
                    .then((response) => {

                        const vendors = response.data;
                        let options = [];
                        for (let data in vendors) {

                            options.push({
                                value: vendors[data].id,
                                label: vendors[data].title + " - " + vendors[data].city,
                            })
                        }
                        setSelectOptions(options)
                        API.getBasics(params)
                            .then((response) => {
                                setBasics(response.data)
                                setIsLoaded(true)
                            })
                            .catch((error) => {

                            });
                    })
                    .catch((error) => {
                        if (error.response) {
                            toast.error(error.response.data.message);
                        } else {
                            toast.error(error.message);
                        }
                    });
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }, []);

    const onUpdateQtyDetails = () => {
        let cartItems = batteryQtyDetails;
        let count = parseInt(battery_qty1);

        let totalCount = parseInt(battery_qty);
        if (cartItems) {
            const find_item = cartItems.find(x => (x.brand === brand && x.amperage === ampType))
            if (find_item) {
                const objIndex = cartItems.findIndex(x => (x.brand === brand && x.amperage === ampType))
                if (isEdit && count === 0) {
                    totalCount = totalCount - find_item.count;
                    cartItems.splice(objIndex, 1)
                } else {
                    if (!isEdit) {
                        totalCount = totalCount + parseInt(count);
                        count += parseInt(find_item.count);
                    }
                    else{
                        totalCount = totalCount - cartItems[objIndex].count;
                        totalCount = totalCount + parseInt(count);
                    }

                    cartItems[objIndex].count = count;
                    cartItems[objIndex].brand = brand;
                    cartItems[objIndex].batteryType = batteryType;
                    cartItems[objIndex].batteryDescription = batteryDescription;

                }

            } else {
                if (count > 0) {
                    totalCount = totalCount + parseInt(count);
                    cartItems.push({ brand, 'amperage': ampType,  count , batteryType, batteryDescription})
                } else {
                    toast.warning('حداقل تعداد وارد شده 1 می باشد')
                    return false
                }

            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            if (count > 0) {
                totalCount = totalCount + parseInt(count);
                cartItems = [];
                cartItems.push({ brand, 'amperage': ampType,  count , batteryType, batteryDescription})
            } else {
                toast.warning('حداقل تعداد وارد شده 1 می باشد')
                return false
            }
        }

        setQtyDetails(cartItems);
        setAmpType('')
        setBrand('')
        setQty1('')
        setBatteryType('')
        setBatteryDescription('')
        setIsEdit(false)
        setQty(totalCount)
    }

    const onButtonClick = () => {

        const request = {
            vendor_id: selectedOptions?.value,
            factor_number: factorNumber,
            battery_qty,
            battery_qty_detail: batteryQtyDetails,
            public_description: description
        }

        setIsLoaded(false);
        API.storeOrder(request)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true);
                setTimeout(() => {
                    navigate('/orders-list/1');
                }, 1000);
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }

    return (
        <React.Fragment>
            <Header/>

            <Navbar page="vendorOrders"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        ثبت سفارش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mt-2">
                                        <div className="form-floating col-12 pt-4">
                                            <Select
                                                options={selectOptions}
                                                placeholder="انتخاب نماینده"
                                                value={selectedOptions}
                                                className=' py-2 '
                                                isSearchable={true}
                                                onChange={
                                                    (event) => {
                                                        setSelectedOptions(event)
                                                    }
                                                }
                                            />

                                        </div>
                                        <div className="form-floating col-md-6 mt-4">
                                            <input type="text"
                                                   className="form-control px-5 text-left"
                                                   id="username" name="username"
                                                   placeholder="شماره "
                                                   value={factorNumber}
                                                   onChange={
                                                       (ev) => {
                                                           setFactorNumber(ev.target.value)
                                                       }
                                                   }

                                            />
                                            <label htmlFor="mobile" className="right-0">شماره فاکتور سیستم
                                                حسابداری</label>
                                        </div>
                                        <div className="form-floating col-md-6 mt-4">
                                            <input type="number"
                                                   className="form-control px-5 text-left"
                                                   id="username" name="username"
                                                   placeholder="تعداد "
                                                   value={battery_qty}
                                                   disabled={true}

                                            />
                                            <label htmlFor="mobile" className="right-0">
                                                تعداد کل باتری درخواستی
                                            </label>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <div className="card ">
                                                <div className="card-header text-end text-small-2">
                                                    افزودن جزئیات باتری های درخواستی
                                                </div>
                                                <div className="card-body text-small-2">
                                                    <div className="row p-3">

                                                        <div className="col-md-4 mb-2">

                                                            <select
                                                                className="form-control text-center text-small-1"
                                                                id="floatingInput"

                                                                value={brand}
                                                                onChange={
                                                                    (event) => {
                                                                        setBrand(event.target.value)
                                                                    }
                                                                }
                                                            >
                                                                <option value="0">
                                                                    انتخاب برند
                                                                </option>
                                                                {
                                                                    basics?.brands?.map(bt => {
                                                                        return (
                                                                            <option value={bt.name} key={bt.id}>
                                                                                {bt.name}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 mb-2">

                                                            <select
                                                                className="form-control text-center text-small-1"
                                                                id="floatingInput"

                                                                value={ampType}
                                                                onChange={
                                                                    (event) => {
                                                                        setAmpType(event.target.value)
                                                                    }
                                                                }
                                                            >
                                                                <option value="0">
                                                                    انتخاب آمپراژ
                                                                </option>
                                                                {
                                                                    basics?.amperages?.map(bt => {
                                                                        return (
                                                                            <option value={bt.title} key={bt.title}>
                                                                                {bt.title}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 mb-2">
                                                            <select
                                                                className="form-control text-center text-small-1"
                                                                id="floatingInput"

                                                                value={batteryType}
                                                                onChange={
                                                                    (event) => {
                                                                        setBatteryType(event.target.value)
                                                                    }
                                                                }
                                                            >
                                                                <option value="0">
                                                                    انتخاب نوع باتری
                                                                </option>
                                                                <option value='سبک'>
                                                                    سبک
                                                                </option>

                                                                <option value='سنگین'>
                                                                    سنگین
                                                                </option>
                                                                <option value='موتورسیکلت'>
                                                                    موتورسیکلت
                                                                </option>
                                                                <option value='VRLA'>
                                                                    VRLA
                                                                </option>
                                                                <option value='VRLA-M'>
                                                                    VRLA Medium
                                                                </option>
                                                                <option value='VRLA-L'>
                                                                    VRLA Large
                                                                </option>
                                                                <option value='AGM'>
                                                                    AGM
                                                                </option>
                                                                <option value='EFB'>
                                                                    EFB
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-8 mb-2">
                                                            <div className="mb-3">

                                                                <input type="text"
                                                                       className="form-control text-center text-small-1"
                                                                       placeholder="توضیحات"
                                                                       value={batteryDescription}
                                                                       onChange={
                                                                           (val) => {
                                                                               setBatteryDescription(val.target.value)
                                                                           }
                                                                       }

                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-2">
                                                            <div className="mb-3">

                                                                <input type="number"
                                                                       className="form-control text-center text-small-1 border-black"
                                                                       placeholder="تعداد مورد درخواست"
                                                                       value={battery_qty1}
                                                                       onChange={
                                                                           (val) => {
                                                                               setQty1(val.target.value)
                                                                           }
                                                                       }

                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            &nbsp;
                                                        </div>
                                                        <div className="col-md-6">
                                                            <button
                                                                className="btn  w-100 btn-primary   text-small-1 mt-3"
                                                                onClick={onUpdateQtyDetails}
                                                            >افزودن به سفارش
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="card-footer text-body-secondary">
                                                    {
                                                        batteryQtyDetails.length > 0 &&
                                                        <table className="table table-striped text-small-2">
                                                            <thead className='text-center'>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">برند</th>
                                                                <th scope="col">آمپراژ</th>
                                                                <th scope="col">نوع</th>
                                                                <th scope="col">تعداد</th>
                                                                <th scope="col">توضیحات</th>
                                                                <th scope="col">عملیات</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody className='text-center'>
                                                            {
                                                                batteryQtyDetails.map((cart, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <th scope="row">{index + 1}</th>
                                                                            <td>{cart.brand}</td>
                                                                            <td>{cart.amperage}</td>
                                                                            <td>{cart.batteryType}</td>
                                                                            <td>{cart.count}</td>
                                                                            <td>{cart.batteryDescription}</td>
                                                                            <td>
                                                                                <button type="button" className="btn btn-info text-small-3 mx-2"
                                                                                        onClick={() => {
                                                                                            setBrand(cart.brand)
                                                                                            setAmpType(cart.amperage)
                                                                                            setQty1(cart.count)
                                                                                            setBatteryType(cart.batteryType)
                                                                                            setBatteryDescription(cart.batteryDescription)
                                                                                            setIsEdit(true)
                                                                                        }}
                                                                                ><i className="bi bi-pen "></i>  ویرایش</button>

                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    }
                                                    {
                                                        batteryQtyDetails.length > 0 &&
                                                        <ul className='text-small-3 text-muted opacity-75'>
                                                            <li>
                                                                برای ویرایش هر گزینه روی دکمه ویرایش آن ردیف کلیک کنید و برای حذف در هنگام ویرایش تعداد مورد درخواست را 0 وارد کند
                                                            </li>
                                                        </ul>
                                                    }

                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 mt-4">

                                            <div className="form-floating">
                                    <textarea className="form-control" placeholder="توضیحات" id="floatingTextarea"
                                              value={description}
                                              onChange={
                                                  (event) => {
                                                      setDescription(event.target.value)
                                                  }
                                              }
                                    >

                                    </textarea>
                                                <label htmlFor="floatingTextarea" className="right-0">
                                                    توضیحات سفارش
                                                </label>
                                            </div>

                                        </div>

                                        <div className="col-12 p-2 mt-5  ">
                                            <button
                                                className="btn btn-success text-semi-big w-100 p-2 pr-4 "
                                                onClick={onButtonClick}
                                                disabled={!isLoaded}
                                            >
                                                ثبت درخواست خرید
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>


                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default Create;